import './detail.scss';
import { setupLayout } from '../../Shared/layout';
import { appConfig } from '../../../src/appConfig';
import { setupAddThis } from '../../../src/module/add-this';

setupLayout();
setupAddThis(appConfig.addThisId);